export { default as Timestamp } from './Timestamp';
export { default as Actions } from './Actions';
export { default as Confirmation } from './Confirmation';

export const convertValue = (value, unit) => {
  return unit === 'Mbps' ? (value * 1e-6).toPrecision(3) : value;
}
